import React, { useState } from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';
import Form from './Form';

import { useContext as usePaymentMethodsContext } from './Context';

export default function RowActions({ row }) {
  const [show, setShow] = useState(false);

  const {
    state: paymentMethodsState,
    actions: paymentMethodsActions,
    dispatch: paymentMethodsDispatch,
  } = usePaymentMethodsContext();

  const onDeletePaymentMethod = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this payment method?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          paymentMethodsActions.deletePaymentMethod(paymentMethodsDispatch, paymentMethodsState.enterpriseId, row.id);
        }
      },
    );
  };

  return (
    <>
      <div>
        <a onClick={() => setShow(true)} className="mr10">
          <img src={editIcon} />
        </a>
        {row.attributes.is_possible_delete && (
          <a className="mr10" onClick={(e) => onDeletePaymentMethod(e, row)}>
            <img src={deleteIcon} />
          </a>
        )}
      </div>
      <Form
        show={show}
        onHide={() => setShow(false)}
        initValue={row}
      />
    </>
  );
}
